import { render, staticRenderFns } from "./FullElemInPC.vue?vue&type=template&id=3ecb1e15&scoped=true"
import script from "./FullElemInPC.vue?vue&type=script&setup=true&lang=js"
export * from "./FullElemInPC.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FullElemInPC.vue?vue&type=style&index=0&id=3ecb1e15&prod&lang=less"
import style1 from "./FullElemInPC.vue?vue&type=style&index=1&id=3ecb1e15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecb1e15",
  null
  
)

export default component.exports